import { Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CounterButton from "./components/CounterButton";
import { CounterProps } from "./types";
import { boxStyles } from "./utils";

const Counter = ({
  value,
  onChange,
  minValue = 1,
  sx = null,
}: CounterProps) => {
  const handleDecrease = () => {
    const newValue = value - 1;
    if (newValue >= minValue) {
      onChange(newValue);
    }
  };

  const handleIncrease = () => onChange(value + 1);

  return (
    <Box
      sx={{
        width: "fit-content",
        display: "flex",
        ...sx,
      }}
    >
      <CounterButton
        onClick={handleDecrease}
        disabled={value === minValue}
        sx={{
          borderTopRightRadius: "0px",
          borderBottomRightRadius: "0px",
        }}
      >
        <RemoveIcon />
      </CounterButton>
      <Box sx={boxStyles}>{value}</Box>
      <CounterButton
        onClick={handleIncrease}
        sx={{
          borderTopLeftRadius: "0px",
          borderBottomLeftRadius: "0px",
        }}
      >
        <AddIcon />
      </CounterButton>
    </Box>
  );
};

export default Counter;
